const brand = process.env.REACT_APP_BRAND;

const config = require(`./brands/${brand}/config`).default;

document.title = config.title;

export default config;